import snackBarReducer from '../modules/reducers/snackBar/reducers'
import userReducer from '../modules/reducers/user/reducers'
import contractsReducer from '../modules/reducers/contracts/reducers'
import newsReducer from '../modules/reducers/news/reducers'
import modalReducer from '../modules/reducers/modal/reducers'
import faqReducer from '../modules/reducers/faq/reducers'
import youfirstFilesReducer from '../modules/reducers/youfirstFiles/reducers'
import yfManagerReducer from '../modules/reducers/yfPopin/reducers'
import servicesReducer from '../modules/reducers/services/reducers'
import alertReducer from '../modules/reducers/alert/reducers'
import footerReducer from '../modules/reducers/footer/reducers'
import accessibilityReducer from '../modules/reducers/accessibility/reducers'
import prelevementReducer from '../modules/reducers/prelevement/reducers'
import assuranceReducer from '../modules/reducers/assurance/reducers'
import requestsReducer from '../modules/reducers/requests/reducers'
import dossierReducer from '../modules/reducers/dossier/reducers'

export default {
	snackBar: snackBarReducer,
	user: userReducer,
	contracts: contractsReducer,
	news: newsReducer,
	modal: modalReducer,
	faq: faqReducer,
	youfirstFiles: youfirstFilesReducer,
	yfManager: yfManagerReducer,
	services: servicesReducer,
	alert: alertReducer,
	footer: footerReducer,
	accessibility: accessibilityReducer,
	prelevement: prelevementReducer,
	assurance: assuranceReducer,
	requests: requestsReducer,
	dossier: dossierReducer
}
